import { EArmType } from "./Waypoint";
import { EModuleType } from "./EModuleType";

export enum ETestingType {
  LightPathSwitching = 0,
  ObjectiveSwitching = 1,
  Imaging = 2,
  PlateBump = 3,
  AutoExposure = 4,
  Condenser = 5,
  Movement = 6,
  Reliability = 7,
  BarcodeScan = 8,
}

export enum ETestingSlotSelection {
  Top = 1,
  Middle = 2,
  Bottom = 4,
  All = 8,
}

export interface LightPathSwitchingTestParameter {
  reCenterWellEvery?: number;
  bumpPlateEvery?: number;
  captureImageEvery?: number;
  saveCapturedImageEvery?: number;
  runDiagnosticEvery?: number;
}

export interface ObjectiveSwitchingTestParameter {
  captureImageEvery?: number;
  saveCapturedImageEvery?: number;
}

export interface TestParameter {
  moduleIdentifier: string;
  type: ETestingType;
  objectiveSwitchingTest?: ObjectiveSwitchingTestParameter;
  lightPathSwitchingTest?: LightPathSwitchingTestParameter;
  waypointTest?: WaypointTestParameter;
  plateBumpTest?: PlateBumpTestParameter;
  imagingTest?: ImagingTestParameter;
  movementTest?: MovementTestParameter;
  reliabilityTest?: ReliabilityTestParameter;
  barcodeScanTest?: BarcodeScanTestParameter;
}

export interface BarcodeScanTestParameter {
  numIterations: number | null;
  displayScannedBarcodeResult: boolean;
  moduleIdentifierHotelNumbersMap: Object;
}

export interface WaypointTestParameter {
  numIterations: number;
  tolerance: number;
}

export interface PlateBumpTestParameter {
  useRandomPlate: boolean;
}

export interface ImagingTestParameter {
  plateBump: boolean;
  pauseDuration: number;
}

export interface ModuleArm {
  identifier: string;
  armType: EArmType;
}

export interface MovementTestParameter {
  moduleArms: ModuleArm[];
  carrierMovement: boolean;
  iteration: number;
  isSequential: boolean;
  mfiFilterCubes: boolean;
  tolerance: number;
}

export interface TargetSelectedReliabilityTestParameter {
  identifier: string;
  targetHotel: number;
  targetSlots: number[];
}
export interface ReliabilityTestParameter {
  iteration: number;
  plateSourceModuleIdentifier: string;
  plateSourceHotelNumber: number;
  plateSourceSlotNumber: number;
  selectedTarget: TargetSelectedReliabilityTestParameter[];
}
